export const SET_SELECTED_PLANOWNER_REQUESTED =
  'SET_SELECTED_PLANOWNER_REQUESTED';
export const SET_SELECTED_PLANOWNER_COMPLETED =
  'SET_SELECTED_PLANOWNER_COMPLETED';

export const SET_SELECTED_PLAN_REQUESTED = 'SET_SELECTED_PLAN_REQUESTED';
export const SET_SELECTED_PLAN_COMPLETED = 'SET_SELECTED_PLAN_COMPLETED';

export const RESET_SELECTED_PLAN_REQUESTED = 'RESET_SELECTED_PLAN_REQUESTED';
export const RESET_SELECTED_PLAN_COMPLETED = 'RESET_SELECTED_PLAN_COMPLETED';

export const SET_SELECTED_SUBPLAN_REQUESTED = 'SET_SELECTED_SUBPLAN_REQUESTED';
export const SET_SELECTED_SUBPLAN_COMPLETED = 'SET_SELECTED_SUBPLAN_COMPLETED';

export const RESET_SELECTED_SUBPLAN_REQUESTED =
  'RESET_SELECTED_SUBPLAN_REQUESTED';
export const RESET_SELECTED_SUBPLAN_COMPLETED =
  'RESET_SELECTED_SUBPLAN_COMPLETED';

export const SET_INITIAL_PLAN_REQUESTED = 'SET_INITIAL_PLAN_REQUESTED';
export const SET_INITIAL_PLAN_COMPLETED = 'SET_INITIAL_PLAN_COMPLETED';

export const RESET_INITIAL_PLAN_REQUESTED = 'RESET_INITIAL_PLAN_REQUESTED';
export const RESET_INITIAL_PLAN_COMPLETED = 'RESET_INITIAL_PLAN_COMPLETED';

export const CHANGE_SELECTED_PLAN_REQUESTED = 'CHANGE_SELECTED_PLAN_REQUESTED';
export const CHANGE_SELECTED_PLAN_COMPLETED = 'CHANGE_SELECTED_PLAN_COMPLETED';

export const RESET_SELECTED_REQUESTED = 'RESET_SELECTED_REQUESTED';
export const RESET_SELECTED_COMPLETED = 'RESET_SELECTED_COMPLETED';
